module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_desalles_sm-6b2790acb1b11d21c44f308340fbcf2e.png";